<template lang="html">
  <div class="animated fadeIn">
    <b-card no-body>
       <b-card-body fluid="xl">
         <b-form v-on:submit.prevent="getMonthReadings" v-on:reset.prevent="onReset" novalidate>
           <b-row>
             <b-col>
               <b-form-group label="House No" label-for="houseno">
                 <v-select ref="houseno"
                           id="houseno"
                           placeholder="House No"
                           name="houseno"
                           :class="{ danger: $v.form.houseno.$error }"
                           @search:blur="$v.form.houseno.$touch()"

                           :options="houseNoList"
                           aria-describedby="liveFeedbackhouseno"
                           v-model="$v.form.houseno.$model"
                           :reduce="house => house.id"
                           label="houseno"></v-select>
                 <span v-show="$v.form.houseno.$error" class="danger-span">
                    This is required field.
                  </span>
                 <b-form-invalid-feedback id="liveFeedbackhouseno">
                   This is a required field.
                 </b-form-invalid-feedback>
               </b-form-group>
             </b-col>
           </b-row>
           <b-row>
             <b-col cols="12">
               <b-form-group label="Select Month:"  label-for="readingMonth">
                 <vue-monthly-picker v-model="$v.form.readingMonth.$model"
                                      :monthLabels="this.months" dateFormat="MMMM/YYYY">
                 </vue-monthly-picker>


               </b-form-group>
             </b-col>
           </b-row>
           <b-row>
             <b-col sm="4">
               <b-btn type="submit" variant="success" :disabled="$v.form.$invalid">Submit</b-btn>
             </b-col>
           </b-row>
         </b-form>
       </b-card-body>
     </b-card>
  <b-card v-if="readings!=null && Object.keys(readings).length > 0" >
    <b-row>
      <b-col>
        <b-table hover    foot-clone :busy="isBusy" :items="readings" :fields="fields" id="dataTable" ref="dataTable" responsive="sm">
          <template #table-busy>
             <div class="text-center text-danger my-2">
               <b-spinner class="align-middle"></b-spinner>
               <strong>Loading...</strong>
             </div>
          </template>
          <template v-slot:cell(isNewMeter)="row">
            <b-form-checkbox
                            :id="`newmeter-${row.index}`"
                            :ref="`newmeter-${row.index}`"
                            :checked="getNewMeterModel(row)"
                            @change="setNewMeterModel($event,row)"
                            :disabled="row.item.fixed == 1"
                            switch>

            </b-form-checkbox>
          </template>

          <template v-slot:cell(remarks)="row">
             <b-form-group label="" label-for="remarks">
               <b-form-input
                             :id="`remarks-${row.index}`"
                             :ref="`remarks-${row.index}`"
                             :readonly="row.item.fixed  == 1"
                             type="text"
                             v-model="form.readings[row.index].remarks"
                             :state="validateState('readings')"
                             :aria-describedby="`liveFeedbackcurrent-${row.index}`"
                             @blur="updateUnitBalace(row, true)"
                             placeholder="Current Reading" />
             </b-form-group>
          </template>
          <template v-slot:cell(currentReading)="row">
             <b-form-group label="" label-for="current">
               <b-form-input
                             :id="`current-${row.index}`"
                             :ref="`current-${row.index}`"
                             :readonly="row.item.fixed  == 1"
                             type="number"
                             :value="getModel(row)"
                             @change="setModel($event,row)"
                             :state="validateState('readings')"
                             :aria-describedby="`liveFeedbackcurrent-${row.index}`"
                             @blur="updateUnitBalace(row, false)"
                             placeholder="Current Reading" />
               <b-form-invalid-feedback :id="`liveFeedbackcurrent-${row.index}`">
                   This field can only contain numbers.
               </b-form-invalid-feedback>
             </b-form-group>
           </template>
           <template v-slot:foot(balance)="data">
               <b variant="primary">Total Balance: {{getLinesTotal()}}</b>
             </template>
           <template v-slot:foot()="data">
               <span></span>
             </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
  <b-card v-if="readings!=null && Object.keys(readings).length > 0">
    <b-row>
      <b-col cols="12">
        <b-button type="submit" @click="submitReadings" variant="primary" :disabled="$v.form.$invalid">
          Save
        </b-button>
      </b-col>
    </b-row>
  </b-card>

  </div>
</template>


<script>
  import Vue from 'vue'
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import {
    mapState,
    mapActions
  } from 'vuex'
  import moment from 'moment'
  import { validationMixin } from "vuelidate";
  import { required, minValue, decimal,minLength,alpha } from "vuelidate/lib/validators";
  const formShape = {
    readingMonth: null,
    readings: [],
    houseno: null
  }


  export default {
    name: 'HouseReadingEdit',
    mixins: [validationMixin],

    data: function() {
      return {
        form: Object.assign({}, formShape),
        submitted: false,
        fields: [

                    {key:'isNewMeter', label:'New Meter'},
                    {key:'currentReading', label:'Saved Reading'}, {key:'remarks', label:'Description'},
                    {key:'lastReading', label:'Last Reading'},
                    {key:'units', label:'Total Units'}, {key:'balance', label:'Reading Balance'},

                ],

        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        isBusy: false,
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],

      }
    },
    computed: {

      readings(){
        return this.form.readings;

      },
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },
      getCurrentMonth(){
        return new Date().getMonth();
      },
      getCurrentYear(){
        return new Date().getFullYear();
      },
      houseNoList(){
        return map(this.$store.state.electrical.houseNoList, (profile) => {
        return {
          houseno: profile.houseno + ' - '  +  profile.name,
          id: profile.id
        }
        })
      }
    },
    validations: {
      form: {
        readingMonth: {
          required
        },
        houseno:{
          required

        },
        readings:{
          $each: {
            currentReading: {
              minValue: minValue(0),
              decimal,
              minLength: minLength(1)
            },
            balance: {
              decimal
            },
            units: {
              decimal,
              minValue: minValue(0),
            }
          }
      }
      }
    },
    methods:{
      getLinesTotal(){
        let balance =  this.form.readings.reduce((acc, reading) => {
          return  (parseFloat(acc) + parseFloat(reading.balance))
        }, 0);
        return parseFloat(balance).toFixed(2);
      },
      getIndex(index){
        return  (this.currentPage -1) * this.perPage + index;
      },
      setReadingMonth(date){
        this.form.readingMonth = date;
      },
      updateUnitBalace(row, checkRemarks){

        if(row.item.fixed == 0){
          let index =  row.index;
          if(row.item.currentReading <= 0 && row.item.isNewMeter == false && row.item.lastReading != 0){
            this.showErrorMsg({message: "Reading must be 0 or greater. Please enter valid value."});
            var textRef = 'current-' + index;
            this.$refs[textRef].focus();
            return;
          }
          else if(row.item.currentReading < row.item.lastReading && row.item.isNewMeter == false){
            this.showErrorMsg({message: "Current Reading must be greater or equal to Previous reading when New Meter is not checked. Please enter valid value."});
            var textRef = 'current-' + index;
            this.$refs[textRef].focus();
            return;
          }
          else if(row.item.currentReading != row.item.lastReading && checkRemarks == true && (row.item.remarks == null || row.item.remarks.length == 0)){
            this.showErrorMsg({message: "Description must be supplied when changing the current reading."});
            var textRef = 'remarks-' + index;
            this.$refs[textRef].focus();
            return;
          }
          else {
            if(isNaN(parseFloat(row.item.currentReading)) && row.item.isNewMeter == true){
              this.showErrorMsg({message: "Current Reading cannot be empty when New Meter is checked. Please enter valid value."});
              var textRef = 'current-' + index;
              this.$refs[textRef].focus();
              return;
            }
          }

            if(row.item.isNewMeter == true) {
              this.form.readings[index]['units'] =  row.item.currentReading
            }
            else{
              this.form.readings[index]['units'] = row.item.currentReading - row.item.lastReading;
            }


            let tempBalance = (this.form.readings[index]['units'] * this.form.readings[index]['chargeAmount'])
            this.form.readings[index]['balance'] = tempBalance.toFixed(2);
        }



      },
      getModel(row){
        let index =  row.index;
        return this.form.readings[index].currentReading;
      },
      setModel(value, row){
        let index =  row.index;
        this.form.readings[index]['currentReading'] = value;
      },
      getNewMeterModel(row){

        let index = row.index;
        return this.form.readings[index]['isNewMeter'];
      },
      setNewMeterModel(value, row){
        if(row.item.fixed == 0){
          let index =  row.index;
          var textRef = 'newmeter-' + index;
          if(value == false){
            if(row.item.currentReading <= 0 && row.item.lastReading != 0){
                this.showErrorMsg({message: "Reading must be 0 or greater. Please enter valid value."});
                let checkRef = 'newmeter-' + index;
                this.$refs[checkRef].localChecked = true;
                let textRef = 'current-' + index;
                this.$refs[textRef].focus();
                this.form.readings[index]['isNewMeter'] = false;
                return;
            }
            else if(row.item.currentReading < row.item.lastReading){
              this.showErrorMsg({message: "Current Reading must be greater or equal to Previous reading when New Meter is not checked. Please enter valid value."});
              let checkRef = 'newmeter-' + index;
              this.$refs[checkRef].localChecked = true;
              let textRef = 'current-' + index;
              this.$refs[textRef].focus();
              this.form.readings[index]['isNewMeter'] = false;
              return;
            }

          }
           this.form.readings[index]['isNewMeter'] = value;
            var textRef = 'newmeter-' + index;
            this.$refs[textRef].localChecked = value;
        }

        },

      validateState(index) {
        const { $dirty, $error } = this.$v.form[index]
        return $dirty ? !$error : null

      },
      getMonthReadings(){
              this.form.readings = null;
              this.isBusy = true;
              this.$nextTick(() => {
                this.$store.dispatch('electrical/getReadingByProfileMonth', {readingMonth: this.form.readingMonth.month() + 1,readingYear: this.form.readingMonth.year(), profile: this.form.houseno.id})
                  .then((response) => {
                    if(response.data.success == false){
                        this.showErrorMsg({
                          message: response.data.error
                        });
                    }
                    else{
                        response.data.data.forEach(reading => {
                          if(reading['fixed'] == 0){
                            reading['isNewMeter'] = false;
                            reading['remarks'] = "";
                          }

                        })

                        this.form.readings = response.data.data;
                        this.isBusy = false;
                      }
                  })
                  .catch((error) => {

                    if (error.response.status == 400) {
                      this.showErrorMsg({
                        message: error.response.data.message
                      })
                    }
                    else if (error.response.status == 422){
                        this.showErrorMsg({
                          message: error.response.data.message
                        });

                    }
                    else {
                      this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                    }
                    this.isBusy = false;
                  })
              })

      },
      submitReadings() {
          if(this.isValid){
          this.$nextTick(() => {
            let exists = this.form.readings.some(function(value, pos, readings){

              if(value.fixed == 0){
                if(value.currentReading <= 0 && value.isNewMeter == false && value.lastReading != 0){
                  let index =  pos;
                  let textRef = 'current-' + index;
                  this.$refs[textRef].focus();
                  this.showErrorMsg({message: "Reading must be 0 or greater. Please enter valid value."})
                  return true;
                }
                else if(value.currentReading < value.lastReading && value.isNewMeter == false){
                  this.showErrorMsg({message: "Current Reading must be greater or equal to Previous reading when New Meter is not checked. Please enter valid value."});
                  let index =  pos;
                  let textRef = 'current-' + index;
                  this.$refs[textRef].focus();
                  this.form.readings[index]['isNewMeter'] = false;
                  return true;
                }
                else if(value.currentReading != value.lastReading && (value.remarks == null || value.remarks.length == 0)){
                  this.showErrorMsg({message: "Description must be supplied when changing the current reading."});
                  let index =  pos;
                  var textRef = 'remarks-' + index;
                  this.$refs[textRef].focus();
                  return true;
                }
                else {
                  if(isNaN(parseFloat(value.currentReading)) && value.isNewMeter == true){
                    this.showErrorMsg({message: "Current Reading cannot be empty when New Meter is checked. Please enter valid value."});
                    var textRef = 'current-' + pos;
                    this.$refs[textRef].focus();
                    return true;
                  }
                }
              }

            }, this);

            if(exists == true){
              return;
            }
            let nonfixedreadings =   this.form.readings.filter(function(r) {
                                        return r.fixed == 0
                                      });

            let parameters = {period: {
                                        month: this.form.readingMonth.month() + 1,
                                        year: this.form.readingMonth.year()
                                      },
                              readings:   map(nonfixedreadings, (value, key) => {
                                                  return {
                                                    id: value.id,
                                                    balance: value.balance,
                                                    currentReading: value.currentReading,
                                                    units: value.units,
                                                    newMeter: value.isNewMeter,
                                                    lastReading: value.lastReading,
                                                    remarks: value.remarks
                                                  }
                                                })
                              }


           this.$store.dispatch('electrical/editReadings', parameters)
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                }
                else{
                    this.showSuccessMsg({
                      message: 'Records saved successfully.'
                    });
                    this.form.readings = null
                  }
              })
              .catch((error) => {

                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.message
                    });

                }
                else {
                  this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
                }
              })

          })
        }
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
    },
    beforeMount() {

    },
    mounted() {

    },
    created(){
      this.form.readingMonth = moment();
      if (this.$store.state.electrical.houseNoList.length == 0) {
        this.$store.dispatch('electrical/getReadingProfiles')
      }
    }

  }
</script>

<style lang="css">
.ag-row-hover {
/* putting in !important so it overrides the theme's styling as it hovers the row also */
background-color: #dfdfff !important;
}

.ag-column-hover {
background-color: #dfffdf;
}
</style>
